import * as ROUTES from '../common/routes';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
// import { ReactComponent as IconNavigation } from '../assets/svg/icon_marker.svg';
// import iconNavigation from '../assets/svg/icon_marker.svg';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';
import {
  GoogleMap,
  useJsApiLoader,
  useLoadScript,
  OverlayView,
  Marker as GoogleMarker,
  InfoWindow,
} from '@react-google-maps/api';

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      markerStyle: {
        width: '20px',
        height: '32px',
        fill: COLORS.appBrown,
        pointerEvents: 'all',
        cursor: 'pointer',
      },
    })
);

const Marker = ({ marker, onClick }: any): JSX.Element => {
  const classes = useStyles();

  const onMarkerClick = (event) => {
    onClick(event, marker);
  };

  const { location: loc, header } = marker.content;
  const lng = parseFloat(loc?.longitude);
  const lat = parseFloat(loc?.latitude);

  // const onLoad = (marker) => {
  //   // console.log('marker: ', marker);
  // };

  return (
    <GoogleMarker
      position={{ lat, lng }}
      // icon={{
      //   url: icon,
      //   anchor: new (window as any).google.maps.Point(5, 58),
      // }}
      // icon={iconNavigation}
      title={header}
      clickable
      onClick={onMarkerClick}
      // onLoad={onLoad}
    ></GoogleMarker>
  );
};

export default Marker;
